@use "@fukuri-admins/ui/layout" as *;

.inputWrapper {
  width: 270px;

  // createSvgIcon 製アイコン（SearchIcon）は .svgIcon クラスが color: text('High') を持つ。
  // TextInput の startIcon スロットが color: text('Placeholder') を指定しても継承で勝てないため、
  // 詳細度を上げて上書きする（scss-patterns.md「SVGR アイコンの色継承」参照）。
  svg {
    color: inherit;
  }
}
